import React from "react";
import PropTypes from "prop-types";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
//Limitless imports
import { PortalTextInput } from "../../../../portal";
import { TownsAutoComplete } from "../../..";
import { useResources } from "@limitless/common/hooks";
const useStyles = makeStyles({
  townsAutoCompleteContainer: {
    marginBottom: 20
  }
});
const ProfileAddressForm = ({
  address,
  onChange,
  fieldErrors,
  isMandatory
}) => {
  const {
    address1,
    address2,
    town,
    postalCode
  } = address;
  const classes = useStyles();
  const {
    resources: {
      towns: {
        towns
      }
    }
  } = useResources();
  const onTownSelect = town => onChange("town", town.value);
  const renderTownsField = () => {
    if ((towns === null || towns === void 0 ? void 0 : towns.length) > 0) {
      return /*#__PURE__*/React.createElement(TownsAutoComplete, {
        id: "townInputField",
        label: "Town / City",
        placeholder: "Select town / city",
        towns: towns,
        selectedTown: town.value,
        onValueChange: onTownSelect,
        background: "white",
        error: fieldErrors.town !== "",
        helperText: fieldErrors.town,
        isMandatory: isMandatory,
        containerStyles: classes.townsAutoCompleteContainer,
        maxMenuHeight: 84,
        minMenuHeight: 84
      });
    }
    return /*#__PURE__*/React.createElement(PortalTextInput, {
      name: "town",
      label: "Town / City",
      placeholder: "Type town / city",
      id: "townInputField",
      onChange: event => onChange("town", event.target.value),
      value: town.value,
      fullWidth: true,
      background: "white",
      isMandatory: isMandatory,
      error: fieldErrors.town !== "",
      helperText: fieldErrors.town
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PortalTextInput, {
    name: "address1",
    label: "Address line 1",
    placeholder: "Type address line 1",
    id: "address1InputField",
    onChange: event => onChange("address1", event.target.value),
    value: address1.value,
    fullWidth: true,
    background: "white",
    isMandatory: isMandatory,
    error: fieldErrors.address1 !== "",
    helperText: fieldErrors.address1
  }), /*#__PURE__*/React.createElement(PortalTextInput, {
    name: "address2",
    label: "Address line 2",
    placeholder: "Type address line 2",
    id: "address2InputField",
    onChange: event => onChange("address2", event.target.value),
    value: address2.value,
    fullWidth: true,
    background: "white",
    error: fieldErrors.address2 !== "",
    helperText: fieldErrors.address2
  }), renderTownsField(), /*#__PURE__*/React.createElement(PortalTextInput, {
    name: "postalCode",
    label: "Postal code",
    placeholder: "Type postal code",
    id: "postalInputField",
    onChange: event => onChange("postalCode", event.target.value),
    value: postalCode.value,
    fullWidth: true,
    background: "white",
    isMandatory: isMandatory,
    error: fieldErrors.postalCode !== "",
    helperText: fieldErrors.postalCode
  }));
};
export default ProfileAddressForm;
ProfileAddressForm.propTypes = {
  address: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  fieldErrors: PropTypes.object.isRequired,
  isMandatory: PropTypes.bool.isRequired
};